import React from 'react';
import Tab from './Tab/Tab';
import Feature from '../Feature/Feature';
import Text from '../../helpers/Text';
import DOMPurify from 'dompurify';
import './TabManager.css';

function TabManager({tabs, selectedTab, onTabClick}) {
    const renderTabs = () => {
        return tabs.map((tab, index) => {
            const selected = tab.id === selectedTab;
            return <Tab key={index} id={tab.id} title={tab.title} selected={selected} isLoading={tab.isLoading} loaded={tab.loaded} onClick={onTabClick}/>;
        });
    };

    const renderContent = () => {
        const match = tabs.find((tab) => tab.id === selectedTab);
        if (!match) return '';
        switch (match.type) {
            case 'text':
                return match.content;
            case 'html':
                return renderHTML(match.content);
            case 'table':
                return renderTable(match.content, match.map);
            default:
                return '';
        }
    };

    const renderHTML = (html) => {
        const sanitized = DOMPurify.sanitize(html);
        return <div dangerouslySetInnerHTML={{__html: sanitized}}/>;
    };

    const renderTable = (list, map) => {
        const filtered = list.filter((item) => item.visible);
        const sorted = filtered.sort((item1, item2) => item1.order - item2.order);
        return sorted.map((item, index) => {
            let id = item.name;
            if (map) {
                const match = map.find((item) => item.originValue === id);
                if (match) id = match.currentValue;
            }
            return <Feature
                key={`feature-${index}`}
                id={Text.capitalizeAll(id)}
                value={item.value || '-'}
            />
        });
    };

    return (
        <div className='tab-manager'>
            <div className='tab-manager_tabs'>{renderTabs()}</div>
            <div className='tab-manager_content'>{renderContent()}</div>
        </div>
    );
}

export default TabManager;